import React, { useState } from "react";
import "./tournament-elite.css";
import Jersey from "../../assets/images/rrc/sibol/OFFICIAL_JERSEY.jpg"
import Jersey2 from "../../assets/images/rrc/sibol/ALTERNATE JERSEY.jpg"
import Sibol from "../../assets/images/rrc/sibol/SIBOL_LOGO.png"
import SibolIcon from "../../assets/images/rrc/sibol/SIBOL_ICON_WHT.png"
import VideoBG from "../../assets/videos/sibol2.mp4"
import GCashQR from "../../assets/images/rrc/sibol/shaunQR.jpg" // 👈 add your QR image here
import { db } from "../../firebase";
import { collection, addDoc } from "firebase/firestore";
import emailjs from "emailjs-com";
import { serverTimestamp } from "firebase/firestore";

const FloatingBloom = () => {
    const petals = Array.from({ length: 24 });
    const flowerTypes = ['🌸', '🌺', '🌷', '✨', '•'];
    return (
        <div className="bloom-container">
            <div className="glow-orb" style={{ top: '5%', left: '10%' }}></div>
            <div className="glow-orb" style={{ top: '40%', right: '15%', animationDelay: '3s', width: '300px' }}></div>
            <div className="glow-orb" style={{ bottom: '5%', left: '20%', animationDelay: '5s' }}></div>
            {petals.map((_, i) => (
                <span key={i} className="petal" style={{
                    left: `${Math.random() * 100}%`,
                    animationDelay: `${Math.random() * 20}s`,
                    fontSize: `${Math.random() * 25 + 10}px`,
                    opacity: Math.random() * 0.5 + 0.2,
                }}>{flowerTypes[i % flowerTypes.length]}</span>
            ))}
        </div>
    );
};

const JERSEY_PRICE = 500;
const GCASH_NUMBER = "09970985227";
const GCASH_NAME = "Manuel Christian M.";
//const ORDER_DEADLINE = "May 15, 2026";

const JERSEY_DESIGNS = [
    { id: "design_a", label: "Main Jersey", image: Jersey },
    { id: "design_b", label: "Alternate Jersey", image: Jersey2 },
];

export default function SibolJerseyOrder() {
    const [step, setStep] = useState(1);
    const [zoomedImage, setZoomedImage] = useState(null);
    const [showSizeChart, setShowSizeChart] = useState(false);
    const [showGCashModal, setShowGCashModal] = useState(false);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [copied, setCopied] = useState(false);

    const [personalInfo, setPersonalInfo] = useState({
        fullName: '',
        email: '',
        contactNumber: '',
        deliveryAddress: ''
    });

    const [jerseyForm, setJerseyForm] = useState({
        items: [{ size: 'M', name: '', design: 'design_a' }],
        gcashRef: ''
    });

    const total = jerseyForm.items.length * JERSEY_PRICE;
    const peso = (n) => `₱${n.toLocaleString()}`;

    const copyGCash = () => {
        navigator.clipboard.writeText(GCASH_NUMBER).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    const validateStep = () => {
        let newErrors = {};

        if (step === 1) {
            if (!personalInfo.fullName.trim()) newErrors.fullName = "Full name is required";
            if (!/^\S+@\S+\.\S+$/.test(personalInfo.email)) newErrors.email = "Invalid email format";
            if (personalInfo.contactNumber.length < 10) newErrors.contact = "Invalid contact number";
        }

        if (step === 2) {
            jerseyForm.items.forEach((item, i) => {
                if (!item.name.trim()) newErrors[`jerseyName_${i}`] = `Jersey ${i + 1} needs a name`;
            });
        }

        if (step === 3) {
            if (!jerseyForm.gcashRef.trim()) newErrors.gcash = "GCash reference number is required";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const next = () => { if (validateStep()) setStep(s => s + 1); };
    const prev = () => { setErrors({}); setStep(s => s - 1); };

    const addJersey = () => {
        setJerseyForm({
            ...jerseyForm,
            items: [...jerseyForm.items, { size: 'M', name: '', design: 'design_a' }]
        });
    };

    const removeJersey = (index) => {
        if (jerseyForm.items.length === 1) return;
        setJerseyForm({ ...jerseyForm, items: jerseyForm.items.filter((_, i) => i !== index) });
    };

    const updateItem = (index, field, value) => {
        const items = [...jerseyForm.items];
        items[index][field] = value;
        setJerseyForm({ ...jerseyForm, items });
    };

    const submitOrder = async () => {
        if (loading || !validateStep()) return;
        setLoading(true);
        try {
            await addDoc(collection(db, "jersey_orders"), {
                personalInfo,
                jerseyForm,
                total,
                itemCount: jerseyForm.items.length,
                paymentStatus: "pending_verification",
                gcashReference: jerseyForm.gcashRef,
                paidAt: serverTimestamp(),
                createdAt: serverTimestamp(),
            });
            await sendEmail();
            setStep(4);
        } catch (error) {
            console.error("Error saving:", error);
        } finally {
            setLoading(false);
        }
    };

    const sendEmail = async () => {
        const jerseyList = jerseyForm.items
            .map((item, i) => `${i + 1}. ${item.name || 'NO NAME'} — Size ${item.size} — ${item.design === 'design_a' ? 'Main Jersey' : 'Alternate Jersey'}`)
            .join('\n');

        const templateParams = {
            fullName: personalInfo.fullName,
            email: personalInfo.email,
            total,
            itemCount: jerseyForm.items.length,
            jerseyList,
            gcashReference: jerseyForm.gcashRef,
            paymentStatus: "For Verification",
            paymentMessage: `✅ PAYMENT SUBMITTED\n\nYour payment is under verification.\nReference: ${jerseyForm.gcashRef}\nWe will confirm your order once payment is validated.`,
        };

        try {
            await emailjs.send("service_4wm9uls", "template_amg4kpt", templateParams, "DNFDReNS3HhYJKknc");
        } catch (err) {
            console.error("Email error:", err);
        }
    };

    return (
        <div className="sibol-theme-wrapper">
            <video autoPlay muted loop playsInline className="sibol-video-bg">
                <source src={VideoBG} type="video/mp4" />
            </video>
            <FloatingBloom />

            <div className="container position-relative py-4" style={{ zIndex: 2 }}>
                <header className="text-center pb-4">
                    <img src="/logo512.png" alt="RRC" className="rrc-main-logo mb-2" />
                    <h1><img src={Sibol} alt="Sibol" className="rrc-main-logo mb-2" /></h1>
                </header>

                {/* PROGRESS BAR */}
                <div className="row justify-content-center mb-4">
                    <div className="col-lg-6 col-md-8 px-4">
                        <div className="d-flex justify-content-between mb-2">
                            <span className="tiny-label opacity-75">Step {step} of 4</span>
                            <span className="tiny-label text-purple-sibol fw-bold">
                                {step === 1 && "Details"}
                                {step === 2 && "Jerseys"}
                                {step === 3 && "Payment"}
                                {step === 4 && "Confirmed"}
                            </span>
                        </div>
                        <div className="stepper-progress-bg">
                            <div className="stepper-progress-fill" style={{ width: `${(step / 4) * 100}%` }}></div>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center pb-5">
                    <div className="col-lg-6 col-md-8">

                        {/* STEP 1: CONTACT INFO */}
                        {step === 1 && (
                            <div className="glass-card p-4 p-md-5 animate-fade-in">
                                <h4 className="fw-800 mb-1">Your Details</h4>
                                <p className="tiny-label opacity-50 mb-4">We'll send your order confirmation here</p>

                                <div className="mb-4">
                                    <label className="tiny-label opacity-50">Full Name</label>
                                    <input placeholder="Racket Dela Cruz"
                                        className={`form-control sibol-input ${errors.fullName ? 'border-danger' : ''}`}
                                        value={personalInfo.fullName}
                                        onChange={e => setPersonalInfo({ ...personalInfo, fullName: e.target.value })} />
                                    {errors.fullName && <small className="text-danger fs-xs">{errors.fullName}</small>}
                                </div>

                                <div className="mb-4">
                                    <label className="tiny-label opacity-50">Email Address</label>
                                    <input placeholder="racketriotclub@gmail.com"
                                        className={`form-control sibol-input ${errors.email ? 'border-danger' : ''}`}
                                        value={personalInfo.email}
                                        onChange={e => setPersonalInfo({ ...personalInfo, email: e.target.value })} />
                                    {errors.email && <small className="text-danger fs-xs">{errors.email}</small>}
                                </div>

                                <div className="mb-4">
                                    <label className="tiny-label opacity-50">Contact Number</label>
                                    <input placeholder="09291234567"
                                        className={`form-control sibol-input ${errors.contact ? 'border-danger' : ''}`}
                                        value={personalInfo.contactNumber}
                                        onChange={e => setPersonalInfo({ ...personalInfo, contactNumber: e.target.value })} />
                                    {errors.contact && <small className="text-danger fs-xs">{errors.contact}</small>}
                                </div>

                                <div className="mb-4">
                                    <label className="tiny-label opacity-50">Delivery Address <span className="opacity-40">(optional)</span></label>
                                    <input placeholder="Brgy. San Jose, Antipolo City"
                                        className="form-control sibol-input"
                                        value={personalInfo.deliveryAddress}
                                        onChange={e => setPersonalInfo({ ...personalInfo, deliveryAddress: e.target.value })} />
                                </div>

                                <button className="sibol-btn w-100 mt-2" onClick={next}>Continue</button>
                            </div>
                        )}

                        {/* STEP 2: JERSEY SELECTION */}
                        {step === 2 && (
                            <div className="glass-card p-4 p-md-5 animate-fade-in">
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <div>
                                        <h4 className="fw-800 m-0">Jersey Order</h4>
                                        <p className="tiny-label opacity-50 m-0">{peso(JERSEY_PRICE)} per jersey</p>
                                    </div>
                                    <button
                                        className="btn btn-link btn-sm text-purple-sibol fw-bold text-decoration-none p-0"
                                        onClick={() => setShowSizeChart(true)}
                                    >
                                        📏 Size Chart
                                    </button>
                                </div>

                                {/* Jersey Items */}
                                <div className="jersey-list mb-3">
                                    {jerseyForm.items.map((item, i) => (
                                        <div key={i} className="p-3 mb-4 rounded-4 border-glass bg-black-20">

                                            {/* Item Header */}
                                            <div className="d-flex align-items-center justify-content-between mb-3">
                                                <span className="tiny-label opacity-50">Jersey #{i + 1} — {peso(JERSEY_PRICE)}</span>
                                                {i > 0 && (
                                                    <button className="btn btn-link btn-sm text-danger p-0 text-decoration-none"
                                                        onClick={() => removeJersey(i)}>
                                                        Remove
                                                    </button>
                                                )}
                                            </div>

                                            {/* Design Picker — both designs shown side by side */}
                                            <label className="tiny-label opacity-50 mb-2 d-block">Choose Design</label>
                                          <div className="d-flex gap-2 mb-3">
  {JERSEY_DESIGNS.map((design, index) => (
    <div
      key={design.id}
      className="flex-fill rounded-3 overflow-hidden position-relative cursor-pointer"
      style={{
        border: item.design === design.id
          ? '2px solid var(--bs-purple, #a87bff)'
          : '2px solid transparent',
        transition: 'border 0.2s',
      }}
      onClick={() => updateItem(i, 'design', design.id)}
    >
      <img
        src={design.image}
        alt={design.label}
        style={{ width: '100%', aspectRatio: '3/4', objectFit: 'cover', display: 'block' }}
      />

      {/* NEW: Included for Tournament Participants Message (First Design Only) */}
      {index === 0 && (
        <div 
          className="position-absolute w-100 text-center py-1"
          style={{ 
            bottom: 0, 
            background: 'rgba(168, 123, 255, 0.9)', 
            color: 'white', 
            fontSize: '6px', 
            fontWeight: 800,
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            zIndex: 2
          }}
        >
          Included in the Tournament Fee
        </div>
      )}

      {/* Enlarge button */}
      <button
        className="btn btn-sm position-absolute"
        style={{ 
          top: 6, // Moved to top right to avoid overlap with bottom text
          right: 6, 
          padding: '2px 6px', 
          fontSize: '10px', 
          background: 'rgba(0,0,0,0.4)', 
          color: 'white', 
          border: 'none', 
          borderRadius: 4,
          zIndex: 3
        }}
        onClick={e => { e.stopPropagation(); setZoomedImage(design.image); }}
      >
        🔍
      </button>

      {/* Selected badge */}
      {item.design === design.id && (
        <div style={{
          position: 'absolute', top: 6, left: 6,
          background: 'var(--bs-purple, #a87bff)',
          color: 'white', fontSize: '10px', fontWeight: 700,
          padding: '2px 8px', borderRadius: 20,
          zIndex: 3
        }}>
          ✓ {design.label}
        </div>
      )}

      {/* Unselected label badge */}
      {item.design !== design.id && (
        <div style={{
          position: 'absolute', top: 6, left: 6,
          background: 'rgba(0,0,0,0.5)',
          color: 'rgba(255,255,255,0.7)', fontSize: '10px',
          padding: '2px 8px', borderRadius: 20,
          zIndex: 3
        }}>
          {design.label}
        </div>
      )}
    </div>
  ))}
</div>

                                            {/* Name + Size Row */}
                                            <div className="d-flex align-items-end gap-3">
                                                <div className="flex-grow-1">
                                                    <label className="tiny-label opacity-50 mb-1 d-block">Name on Jersey</label>
                                                    <input
                                                        className={`form-control sibol-input bg-transparent border-0 px-0 fw-bold ${errors[`jerseyName_${i}`] ? 'border-danger' : ''}`}
                                                        placeholder="E.g. DELA CRUZ"
                                                        value={item.name}
                                                        onChange={e => updateItem(i, 'name', e.target.value.toUpperCase())}
                                                    />
                                                    {errors[`jerseyName_${i}`] && (
                                                        <small className="text-danger fs-xs">{errors[`jerseyName_${i}`]}</small>
                                                    )}
                                                </div>
                                                <div style={{ width: '80px' }}>
                                                    <label className="tiny-label opacity-50 mb-1 d-block text-end">Size</label>
                                                    <select
                                                        className="form-select sibol-input border-0 bg-transparent px-0 text-end fw-bold"
                                                        value={item.size}
                                                        onChange={e => updateItem(i, 'size', e.target.value)}
                                                    >
                                                        {['12', '14', '16', '18', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'].map(s => (
                                                            <option key={s} value={s} className="bg-dark">{s}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {/* Add Jersey */}
                                <button className="btn w-100 mb-4 text-purple-sibol border-glass rounded-3 py-2" onClick={addJersey}>
                                    + Add Another Jersey
                                </button>

                                {/* Running Total */}
                                <div className="d-flex justify-content-between small opacity-75 mb-4 px-1">
                                    <span>{jerseyForm.items.length} jersey{jerseyForm.items.length > 1 ? 's' : ''}</span>
                                    <span className="fw-bold text-purple-sibol">{peso(total)}</span>
                                </div>

                                <div className="d-flex gap-3">
                                    <button className="btn text-white-50 w-25" onClick={prev}>Back</button>
                                    <button className="sibol-btn w-75" onClick={next}>Continue</button>
                                </div>
                            </div>
                        )}

                        {/* STEP 3: PAYMENT */}
                        {step === 3 && (
                            <div className="glass-card p-4 p-md-5 animate-fade-in">
                                <h4 className="fw-800 mb-4">Payment</h4>

                                {/* Order Breakdown */}
                                <div className="p-4 rounded-4 mb-4 border-glass"
                                    style={{ background: 'linear-gradient(145deg, rgba(255,255,255,0.05) 0%, rgba(0,0,0,0.2) 100%)' }}>
                                    {jerseyForm.items.map((item, i) => (
                                        <div key={i} className="d-flex justify-content-between small mb-2 opacity-75">
                                            <span>
                                                {item.name || `Jersey ${i + 1}`} — {item.size}
                                                <span className="ms-2 opacity-50">
                                                    {item.design === 'design_a' ? 'Main Jersey' : 'Alternate Jersey'}
                                                </span>
                                            </span>
                                            <span>{peso(JERSEY_PRICE)}</span>
                                        </div>
                                    ))}
                                    <hr className="opacity-25" />
                                    <div className="d-flex justify-content-between h4 fw-900 mb-0 text-purple-sibol">
                                        <span>Total</span>
                                        <span>{peso(total)}</span>
                                    </div>
                                </div>

                                {/* GCash Payment Block */}
                                <div className="p-4 rounded-4 mb-4 border-glass"
                                    style={{ background: 'rgba(0,0,0,0.2)' }}>

                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <span className="tiny-label opacity-75 fw-bold">Send via GCash</span>
                                        {/* QR Button */}
                                        <button
                                            className="btn btn-sm text-purple-sibol border-glass rounded-3 px-3 py-1"
                                            style={{ fontSize: '12px' }}
                                            onClick={() => setShowGCashModal(true)}
                                        >
                                            📷 View QR Code
                                        </button>
                                    </div>

                                    {/* GCash Number Row — copyable */}
                                    <div className="d-flex align-items-center justify-content-between p-3 rounded-3 mb-2"
                                        style={{ background: 'rgba(255,255,255,0.05)', border: '1px dashed rgba(255,255,255,0.2)' }}>
                                        <div>
                                            <p className="mb-0 fw-bold" style={{ letterSpacing: '0.05em', fontSize: '1.1rem' }}>
                                                {GCASH_NUMBER}
                                            </p>
                                            <p className="mb-0 tiny-label opacity-50">{GCASH_NAME}</p>
                                        </div>
                                        <button
                                            className="btn btn-sm rounded-3 px-3 py-1"
                                            style={{
                                                fontSize: '12px',
                                                background: copied ? 'rgba(40,200,100,0.2)' : 'rgba(255,255,255,0.1)',
                                                color: copied ? '#4ade80' : 'rgba(255,255,255,0.8)',
                                                border: copied ? '1px solid #4ade80' : '1px solid rgba(255,255,255,0.2)',
                                                transition: 'all 0.3s',
                                                minWidth: '60px'
                                            }}
                                            onClick={copyGCash}
                                        >
                                            {copied ? '✓ Copied' : 'Copy'}
                                        </button>
                                    </div>

                                    <p className="tiny-label opacity-40 mb-0">
                                        Amount: <strong className="text-white">{peso(total)}</strong>
                                    </p>
                                </div>

                                {/* Reference Input */}
                                <div className="mb-4">
                                    <label className="tiny-label opacity-50 mb-2 d-block">GCash Reference Number</label>
                                    <input
                                        className={`form-control sibol-input ${errors.gcash ? 'border-danger' : ''}`}
                                        placeholder="Enter reference number after payment"
                                        value={jerseyForm.gcashRef}
                                        onChange={e => setJerseyForm({ ...jerseyForm, gcashRef: e.target.value })}
                                    />
                                    {errors.gcash && <small className="text-danger fs-xs">{errors.gcash}</small>}
                                </div>

                                <div className="d-flex gap-3">
                                    <button className="btn text-white-50 w-25" onClick={prev} disabled={loading}>Back</button>
                                    <button className="sibol-btn w-75" onClick={submitOrder} disabled={loading}>
                                        {loading ? (
                                            <span>
                                                <span className="spinner-border spinner-border-sm me-2"></span>
                                                Processing...
                                            </span>
                                        ) : 'Place Order'}
                                    </button>
                                </div>
                            </div>
                        )}

                        {/* STEP 4: CONFIRMED */}
                        {step === 4 && (
                            <div className="glass-card p-4 p-md-5 text-center animate-fade-in">
                                <div className="mb-4">
                                    <img src={SibolIcon} alt="Sibol" className="rrc-main-logo mb-2" />
                                </div>
                                <h2 className="fw-800 mb-2">Order Placed!</h2>
                                <p className="text-white-50 mb-4 small">
                                    Your jersey order has been received. We'll confirm once payment is verified.
                                </p>

                                <div className="bg-black-20 rounded-4 p-4 mb-4 border-glass text-start">
                                    <div className="mb-3">
                                        <label className="tiny-label opacity-50 d-block">Ordered By</label>
                                        <span className="fw-bold h5 text-purple-sibol">{personalInfo.fullName}</span>
                                    </div>

                                    <div className="row g-3 mb-3">
                                        <div className="col-6">
                                            <label className="tiny-label opacity-50 d-block">Payment</label>
                                            <span className="fw-bold text-warning">● For Verification</span>
                                        </div>
                                        <div className="col-6 text-end">
                                            <label className="tiny-label opacity-50 d-block">Total</label>
                                            <span className="fw-bold">{peso(total)}</span>
                                        </div>
                                    </div>

                                    <hr className="opacity-10" />

                                    <label className="tiny-label opacity-50 d-block mb-2">Items Ordered</label>
                                    {jerseyForm.items.map((item, i) => (
                                        <div key={i} className="d-flex justify-content-between align-items-center mb-1">
                                            <span className="small fw-bold">{item.name || 'NO NAME'}</span>
                                            <div className="d-flex gap-2">
                                                <span className="badge border-glass text-white-50">{item.size}</span>
                                                <span className="badge border-glass text-white-50">
                                                    {item.design === 'design_a' ? 'Main Jersey' : 'Alternate Jersey'}
                                                </span>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <button className="sibol-btn w-100" onClick={() => window.location.reload()}>
                                    Place Another Order
                                </button>
                                <p className="mt-3 tiny-label opacity-50">
                                    A confirmation has been sent to {personalInfo.email}.
                                </p>
                            </div>
                        )}

                    </div>
                </div>
            </div>

            {/* IMAGE ZOOM MODAL */}
            {zoomedImage && (
                <div className="image-zoom-overlay animate-fade-in" onClick={() => setZoomedImage(null)}>
                    <div className="zoom-content-wrapper">
                        <button className="btn-close btn-close-white zoom-close" onClick={() => setZoomedImage(null)}></button>
                        <img src={zoomedImage} alt="Enlarged Preview" className="zoomed-image" />
                    </div>
                </div>
            )}

            {/* GCASH QR MODAL */}
            {showGCashModal && (
                <div className="image-zoom-overlay animate-fade-in" onClick={() => setShowGCashModal(false)}>
                    <div
                        className="glass-card p-4 text-center"
                        style={{ maxWidth: '320px', width: '90%', margin: 'auto' }}
                        onClick={e => e.stopPropagation()}
                    >
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="fw-800 m-0 text-white">GCash QR Code</h5>
                            <button className="btn-close btn-close-white" onClick={() => setShowGCashModal(false)}></button>
                        </div>

                        {/* QR Image */}
                        <div className="rounded-3 overflow-hidden mb-3" style={{ background: 'white', padding: '12px' }}>
                            <img
                                src={GCashQR}
                                alt="GCash QR"
                                style={{ width: '100%', display: 'block', borderRadius: '8px' }}
                            />
                        </div>

                        {/* Account info */}
                        <p className="fw-bold mb-0" style={{ fontSize: '1.1rem', letterSpacing: '0.05em' }}>{GCASH_NUMBER}</p>
                        <p className="tiny-label opacity-50 mb-3">{GCASH_NAME}</p>

                        <p className="small opacity-75 mb-3">
                            Amount: <strong className="text-purple-sibol">{peso(total)}</strong>
                        </p>

                        {/* Save/Download Button */}
                        <a
                            href={GCashQR}
                            download="gcash-qr-sibol.png"
                            className="sibol-btn d-block w-100 text-decoration-none"
                            style={{ textAlign: 'center' }}
                        >
                            ⬇ Save QR Code
                        </a>

                        <p className="mt-3 tiny-label opacity-40">
                            Screenshot or save to pay via GCash app
                        </p>
                    </div>
                </div>
            )}

            {/* SIZE CHART MODAL */}
            {showSizeChart && (
                <div className="size-chart-overlay animate-fade-in" onClick={() => setShowSizeChart(false)}>
                        <div className="glass-card p-0 overflow-hidden size-chart-content shadow-glow"
                            style={{ width: '90%', maxWidth: '420px' }}
                            onClick={e => e.stopPropagation()}>

                            {/* Header Section */}
                            <div className="modal-head d-flex justify-content-between align-items-center p-4 border-bottom border-white-10">
                                <div>
                                    <span className="sibol-subtitle mb-1 d-block">Find Your Fit</span>
                                    <h5 className="m-0 fw-800 text-uppercase tracking-wider text-white">Jersey Size Guide</h5>
                                </div>
                                <button className="close-x text-white opacity-50" onClick={() => setShowSizeChart(false)}>&times;</button>
                            </div>

                            {/* Chart Section */}
                            <div className="modal-body p-0">
                                {/* Header Row - Styled with your theme's purple tint */}
                                <div className="chart-row-sibol header-row-bg">
                                    <div className="col-label tiny-label m-0">SIZE</div>
                                    <div className="col-data tiny-label m-0 text-end">WIDTH (IN)</div>
                                    <div className="col-data tiny-label m-0 text-end">LENGTH (IN)</div>
                                </div>

                                {/* Data Rows with your Custom Scrollbar */}
                                <div className="level-scroll-container px-2" style={{ maxHeight: '380px' }}>
                                    {[
                                        { s: "12", w: 14, l: 21 }, { s: "14", w: 15, l: 22 },
                                        { s: "16", w: 16, l: 23 }, { s: "18", w: 17, l: 24 },
                                        { s: "XS", w: 18, l: 25 }, { s: "S", w: 19, l: 26 },
                                        { s: "M", w: 20, l: 27 }, { s: "L", w: 21, l: 28 },
                                        { s: "XL", w: 22, l: 29 }, { s: "2XL", w: 23, l: 30 },
                                        { s: "3XL", w: 24, l: 31 }, { s: "4XL", w: 25, l: 32 },
                                        { s: "5XL", w: 26, l: 33 }
                                    ].map((row, i) => (
                                        <div key={i} className="chart-row-sibol body-row-style">
                                            <div className="col-label fw-800 text-purple-sibol">{row.s}</div>
                                            <div className="col-data text-end text-white fw-600 opacity-75">{row.w}"</div>
                                            <div className="col-data text-end text-white fw-600 opacity-75">{row.l}"</div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Footer */}
                            <div className="p-3 bg-black-20 text-center border-top border-white-10">
                                <p className="m-0 fs-xs text-white-50 italic">
                                    * Measurements are in inches.
                                </p>
                            </div>
                        </div>
                    </div>
            )}
        </div>
    );
}